export default __webpack_public_path__ + "static/image1-4e36f7a8cacf8e6c75d2554240bab8c7.jpg";